export type IRefreshFieldRelatedValues = (
  formId: string,
  fieldFormLinkId: string,
  parentDataBundleId: string,
  fieldSuffix: string,
  childFields: string,
  appContext: string,
  formLocale: string
) => void;

export function refreshFieldRelatedValues(
  formId: string,
  fieldFormLinkId: string,
  parentDataBundleId: string,
  fieldSuffix: string,
  childFields: string,
  appContext: string,
  formLocale: string
): void {
  // parentDataBundleId is the value of the parent input/dropdown
  const masterDfd = new ($ as any).Deferred(); // Master promise
  let updateFieldRequest = $.when(1);

  $.each(childFields, (_, value) => {
    // START EACH
    updateFieldRequest = updateFieldRequest.then(() => {
      const dfd = new ($ as any).Deferred();
      // If parent field has no value, do nothing
      if (!parentDataBundleId || parentDataBundleId === '') {
        dfd.resolve();
        return dfd.promise();
        // If parent field has value, get filtered child values
      }
      const $mainElement = $(`*[name="field_${value}${fieldSuffix}"]`);
      const $mainElementAutoField = $(`*[name="auto_field_${value}${fieldSuffix}"]`);
      const isSelect = $mainElement.is('select');
      const currentValue = $mainElement.val();
      const currentValues =
        typeof $mainElement.data('current-values') === 'string'
          ? $mainElement.data('current-values')
          : '%5B%5D';
      const currentValuesArray = JSON.parse(decodeURIComponent(currentValues));
      // Add value inside of input to the currentValuesArray
      if (currentValue && currentValue !== '' && currentValuesArray.indexOf(currentValue) === -1) {
        currentValuesArray.push(currentValue);
      }
      const getUrl = `${appContext}/public/data/AjaxGetRelatedValues.action?formId=${formId}&localeCode=${formLocale}&fieldFormLinkId=${value}&parentDataBundleId=${parentDataBundleId}&childDataBundleId=${currentValuesArray.join(
        ','
      )}`;

      // Update child values if needed
      new Promise((resolve, reject) => {
        // Main element is select
        if (isSelect) {
          // Get json
          $.getJSON(`${getUrl}&cacheBust=${window.DexeroCoreApp.getUUID()}`)
            .done((responseData) => {
              // Empty select and add back one empty option
              $mainElement.empty().append('<option value=""></option>');
              // Build options
              const options = responseData.map((resultObject: IDCA.IGenericObj) => {
                // currentValuesArray will be string now, we need to check against string
                const selected =
                  currentValuesArray.indexOf(String(resultObject.id)) !== -1
                    ? 'selected="selected"'
                    : '';
                return `<option value="${resultObject.id}" ${selected}>${resultObject.value}</option>`;
              });
              // Attach to select
              $mainElement.append(options);
              resolve();
            })
            .fail(reject);
        } else {
          // Main element is input
          $mainElement.val(currentValuesArray.join(','));
          resolve();
        }
      }).then(() => {
        // Release elements
        $mainElement.prop('disabled', false).trigger('change');
        $mainElementAutoField.prop('disabled', false).trigger('change');
        const obj = {
          appContext,
          childFields,
          fieldFormLinkId,
          fieldName: $mainElement.attr('name'),
          fieldSuffix,
          formId,
          formLocale,
          parentDataBundleId,
        };
        if (window.debug) {
          ($ as any).log(`refreshFieldRelatedValues/done/${$mainElement.attr('name')}`);
        }
        window.DexeroCoreApp.publish(
          `refreshFieldRelatedValues/done/${$mainElement.attr('name')}`,
          obj
        );
        dfd.resolve();
      });

      return dfd.promise();
    });
  }); // END EACH
  // Once all child fields have been updated resolve master promise
  updateFieldRequest.done(() => {
    masterDfd.resolve();
  });
  // Return master promise
  return masterDfd.promise();
}
